import { formatCallerNumber } from '../../modules/telephony/utils/callFormat';

/** SSE-подія заявки сайту → сповіщення (in-app тост + desktop); форма — як у toastForPromEvent. */
export function toastForSiteLeadEvent(event, data) {
  if (event !== 'site.lead.created') return null;
  return {
    key: `site-lead:${data.leadId}`,
    title: `🌐 Нова заявка з сайту${data.siteName ? ` · ${data.siteName}` : ''}`,
    body: [data.name, data.phone ? formatCallerNumber(data.phone) : null, data.city].filter(Boolean).join(' · '),
    line2: [data.pageTitle ? `📄 ${data.pageTitle}` : null, data.message].filter(Boolean).join(' — '),
    target: `/telephony/site-leads/${data.leadId}`,
    tone: 'info',
    actionLabel: 'Відкрити заявку',
  };
}
